import ReactDOM from 'react-dom/client';
import { convertToCBSupported, fetchMessagesFromCDN, getClientLocale } from '@cbhq/intl';
import { polyfillIntl } from '@cbhq/intl/polyfills';

import { logFundsAccessCriticalStep } from ':fat/analytics/logMetrics';

import { initializeDevTools } from './components/Devtools/initialize';
import { App } from './App';

async function bootstrap() {
  const locale = convertToCBSupported(getClientLocale());

  const [, messages] = await Promise.all([
    polyfillIntl(locale),

    process.env.SMARTLING_PROJECT_ID
      ? fetchMessagesFromCDN(locale, process.env.SMARTLING_PROJECT_ID)
      : Promise.resolve({}),
  ]);

  initializeDevTools();

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <App locale={locale} messages={messages} />,
  );
}

void bootstrap();

logFundsAccessCriticalStep({ step: 'init_session' });

if (module.hot) {
  module.hot.accept();
}
